export default {
  delete: ({ DELETE }, cheque) =>
    new Promise((resolve, reject) => {
      if (!cheque || !cheque.getId()) {
        return reject(new Error(`Erreur paramètre : ID non valide`))
      }
      return DELETE(`cheques/${cheque.getId()}`)
        .then(reponse => {
          const data = reponse.data
          if ([200, 204].includes(reponse.status)) {
            resolve(data)
          } else {
            reject(reponse.status)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
}
